import Landing from "views/examples/Landing";
import TermsOfUse from "views/legal/TermsOfUse";

const routeConfig = [
  {
    path: "/",
    element: <Landing />
  },
  {
    path: "/landing-page",
    element: <Landing />
  },
  {
    path: "/privacy-policies",
    element: <Landing />
  },
  {
    path: "/privacy-policies/",
    element: <Landing />
  },
  {
    path: "/index.php/privacy-policies",
    element: <Landing />
  },
  {
    path: "/index.php/privacy-policies/",
    element: <Landing />
  },
  {
    path: "/terms-of-use",
    element: <TermsOfUse />
  },
  {
    path: "/terms-of-use/",
    element: <TermsOfUse />
  },
  {
    path: "/index.php/terms-of-use",
    element: <TermsOfUse />
  },
  {
    path: "/index.php/terms-of-use/",
    element: <TermsOfUse />
  }
];

export default routeConfig;
